export const BACKEND_API = 'https://api.b-link.io/b-link-ameni-siteweb-backend/';
// export const BACKEND_API = 'http://192.168.1.13:9099/';

export const API_URLS = {
    SEND_CONATCT_MAIL: BACKEND_API + 'contact/sendContactMail'
};
